import gql from "graphql-tag";
import applicantFragment from "shared/Auth/fragments/applicantFragment";
import anyUserFragment from "shared/Auth/fragments/anyUserFragment";

const updateApplicantUniversity = gql`
    mutation UpdateApplicantUniversityMutation($universitySlug: String, $applied: Boolean) {
        updateMyUniversityLink(universitySlug: $universitySlug, applied: $applied) {
            me {
                anyUser {
                    ...AnyUserFull
                }
                applicant {
                    ...ApplicantFull
                }
            }
        }
    }
    ${applicantFragment}
    ${anyUserFragment}
`;

export default updateApplicantUniversity;
